// @ts-nocheck

import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

import { NotConnected1 } from '../../assets/img';
import { __ } from '../../i18n/l10n';
import { Routes } from '../../types/routes';
import MatchRowList from '../MatchRowList';
import MatchRowsFilters from '../MatchRowsFilters';
import NotFoundView from '../NotFoundView';
import TopActionLine from '../TopActionLine';
import WinaLoader from '../WinaLoader';

const StyledTopActionLine = styled(TopActionLine)`
  padding: 0.3em 0.5em;
`;

const RoutesFavorite = ({
  connected,
  view: { isLoading, isNull, isEmpty, list, facets, prefs },
  askRoute,
  setPreferences,
  purgeFavorites,
  anchorMatchId,
}) => {
  const hasWinaTVFilterOn = useMemo(() => !!prefs?.filters?.wtvOnly, [prefs]);

  const hasSome = useMemo(() => (!isNull && !isEmpty) || hasWinaTVFilterOn, [isEmpty, isNull, hasWinaTVFilterOn]);
  const shouldShowMatchList = useMemo(() => connected && !isLoading && hasSome, [connected, hasSome, isLoading]);
  const [scrollTop, setScrollTop] = useState(false);

  useEffect(() => {
    askRoute(Routes.FAVORITES);
  }, [askRoute]);

  if (connected && isLoading) {
    return <WinaLoader delayed />;
  }
  return (
    <>
      {shouldShowMatchList ? (
        <>
          <StyledTopActionLine
            ctaLabel={__('Delete my favourites')}
            label={__('My favourites')}
            onButtonClick={purgeFavorites}
            showButton
          />
          <MatchRowsFilters facets={facets} prefs={prefs} setPreferences={setPreferences} setScrollTop={setScrollTop} />
          <MatchRowList items={list} anchorMatchId={anchorMatchId} scrollTop={scrollTop} setScrollTop={setScrollTop} />
        </>
      ) : null}
      {connected && !hasSome ? <NotFoundView label={__('You have no favourites')} /> : null}
      {!connected ? (
        <NotFoundView imgPath={NotConnected1} label={__('You must be logged in to see this page')} />
      ) : null}
    </>
  );
};

export default RoutesFavorite;
